module.exports = __webpack_public_path__ + "media/images/emoji-4a9bec98c05e15caf60d419e56c0dda8.png";